import { Outlet } from "react-router-dom";
import { ThemeToggle } from "@/components/theme-toggle";

const AuthLayout = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-secondary/20 to-background p-4 relative">
            <div className="absolute top-4 right-4">
                <ThemeToggle />
            </div>
            <Outlet />
        </div>
    );
};

export default AuthLayout;